import AbstractModalBaseController from '../../../../core/abstracts/controllers/modal-base-controller';

export default class AddTicketTemplateModalController extends AbstractModalBaseController {

    constructor($scope, $injector, $uibModalInstance) {
        super($scope, $injector, $uibModalInstance);

        this.api = this.injector.get('$http');
        this.acl = this.injector.get('Acl');
        this.translate = this.injector.get('$translate');
        this.alert = this.injector.get('Alert');

        this.loading = true;

        this.currentAddType = 'new';
        this.availableTemplateTypes = [];
        this.existingTemplates = [];
        this.templateIdToDuplicateFrom = null;

        this.injector
            .get('$q')
            .all([
                this._loadAvailableTypes(),
                this._loadExistingTemplates()
            ])
            .then(() => {
                this.loading = false;
            })
    }

    updateTemplateIdToDuplicateFrom(newValue) {
        this.templateIdToDuplicateFrom = newValue;
        this.scope.$applyAsync();
    }

    duplicateAndLinkTemplate() {
        this.submitting = true;

        this.api
            .post(
                `tickets/templates/${this.templateIdToDuplicateFrom}/duplicate`
            )
            .then(({data}) => {
                this.close({
                    ticketTemplate: data.data
                })
            })
            .catch(e => {
                this.alert.handle(e)
                this.submitting = false;
            })
    }

    createTemplate(templateType) {
        this.loading = true;
        this.api
            .post('tickets/templates/from-template-type', {
                template_type_id: templateType.id
            })
            .then(({data}) => {
                this.close({
                    ticketTemplate: data.data
                })
            })
            .catch(e => {
                this.alert.handle(e)
                this.submitting = false;
            });
    }

    createCustomTemplate() {
        if (!this.acl.hasRight('tickets::templates-create-custom')) {
            this.alert.animatedAlert(
                this.translate.instant('tickets.templates.pages.create.custom_not_enabled.title'),
                this.translate.instant('tickets.templates.pages.create.custom_not_enabled.content'),
                'attention',
                {
                    showCancelButton: false,
                    confirmButtonText: this.translate.instant('general.buttons.ok')
                }
            );
            return;
        }

        this.loading = true;
        this.api
            .post('tickets/templates/custom')
            .then(({data}) => {
                this.close({
                    ticketTemplate: data.data
                })
            })
            .catch(e => {
                this.alert.handle(e)
                this.loading = false;
            });
    }

    _loadAvailableTypes() {
        return this.api
            .get(`tickets/templates/types`)
            .then(({data}) => {
                this.availableTemplateTypes = data.data;
            })
            .catch((e) => {
                this.alert.handle(e);
            })
    }

    _loadExistingTemplates() {
        return this.api
            .post('fp/tickets/templates', {
                fields: [
                    'name',
                    'id'
                ],
                pagination: {
                    perPage: -1
                },
                sort: {
                    name: 'asc'
                }
            })
            .then(({data}) => {
                this.existingTemplates = _.map(data.data, (row) => {
                    return {
                        value: row.id,
                        label: row.name
                    }
                });
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/controllers/modals/add-ticket-template-modal.js